import { Alert, Divider, Row, Typography } from 'antd';
import AddUser from './AddUser.js';
import ShowUser from './ShowUser.js';

const { Title } = Typography;

function UserConfig(props) {
    return (
        <>
            <Divider>
                <Title level={3}>Vorplattler</Title>
            </Divider>
            <Alert
                type="info"
                showIcon={true}
                closable={true}
                message="Bitte einen Vorplattler selektieren, um die Anmeldungen für seinen Verein im Formular anzuzeigen und bearbeiten zu können."
                style={{ marginBottom: 10 }}
            />
            <Row
                gutter={[10,10]}
                style={{ marginBottom: 10 }}
            >
                {
                    props.users.map((user, index) => {
                        return (
                            <ShowUser
                                key={index}
                                id={user.id}
                                email={user.email}
                                association={user.association}
                                onDelete={props.onDelete}
                                onSelect={props.onSelect}
                            />
                        )
                    })
                }
            </Row>
            <AddUser
                onClick={props.onAdd}
            />
        </>
    )
}

export default UserConfig;